module.exports = __webpack_public_path__ + "static/media/ino_payment.4c3de175.svg";